<template>
  <div class="content expert-opinion-wrap">
    <div class="expert-opinion-box">
      <el-row :gutter="20">
        <el-col :xs="24" :lg="18">
          <div class="expert-o-left">
            <div class="experts-teacher">
              <el-row :gutter="20">
                <el-col :xs="24" :lg="8">
                  <div class="t-avatar"><img :src="expert.imgUrl" width="300" height="300" /></div>
                </el-col>
                <el-col :xs="24" :lg="16">
                  <div class="t-info">
                    <h2 class="t-tit">{{expert.expert}}</h2>
                    <ul class="t-list">
                      <template v-for="remark in remarks">
                        <li>◆{{remark}}</li>
                      </template>
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="opinion-list">
              <div class="common-hd">专家观点</div>
              <div class="list-bd">
                <template v-for="item in essays">
                  <a :href="'/px/newsDetails/'+item.id" target="_blank"><i class="qjico opinion-ico"></i>{{item.title}}</a>
                </template>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :lg="6">
          <div class="expert-o-right">
            <div class="hd">其他专家</div>
            <div class="bd">
              <el-row :gutter="20">
                <template v-for="item in experts">
                <el-col :xs="12" :lg="12">
                  <a :href="'/expertOpinion/'+item.id">
                    <img :src="item.imgUrl" width="120" height="120" />
                    <p class="txt">{{item.expert}}</p>
                  </a>
                </el-col>
                </template>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        path: domain.apiUrl,
        id : this.$route.params.id,
        expert: {},//详情
        remarks: [],//观点
        essays: [],//文章
        experts: [],//专家
      }
    },
    created() {
      this.expertInfo();
      this.expertEssay();
      this.otherExpert();
    },
    methods: {
      expertInfo: function() {
        this.$http.get(this.path + 'expert/introduce?expertId='+this.id).then((response) => {
          if (response.status === 200) {
            this.expert = response.body;
            var remark = this.expert.remark.replace(/；/g , ";");
            this.remarks = remark.split(';');
          }
        }, (response) => {
          this.$message.error("error")
        });
      },
      expertEssay: function() {
        this.$http.get(this.path + 'essay/list?expertId='+this.id).then((response) => {
          if (response.status === 200) {
            this.essays = response.body;
          }
        }, (response) => {
          this.$message.error("error")
        });
      },
      otherExpert: function() {
        this.$http.get(this.path + 'expert/otherExperts?id='+this.id).then((response) => {
          if (response.status === 200) {
            this.experts = response.body;
          }
        }, (response) => {
          this.$message.error("error")
        });
      },


    },
  };
</script>

<style lang="scss">
@import '../assets/css/expert.scss';
</style>



// WEBPACK FOOTER //
// src/components/expertOpinion.vue